import { Component, Input } from '@angular/core';
import { EntityDetailDividerStyle } from '../../../../../shared/definitions/entity-detail-divider-style.enum';

@Component({
  selector: 'entity-detail-divider',
  standalone: false,
  templateUrl: './entity-detail-divider.component.html',
  styleUrls: ['./entity-detail-divider.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
})
export class EntityDetailDividerComponent {
  @Input() style: EntityDetailDividerStyle = EntityDetailDividerStyle.Light;
}
